<template>
  <path
    d="M19.73 14.2302L7.70999 2.21022C7.31999 1.82022 6.68999 1.82022 6.29999 2.21022L3.69999 4.80022C3.35999 5.14022 3.30999 5.68022 3.58999 6.08022L11.24 17.0602C10.46 17.8402 10.46 19.1102 11.24 19.8902L12.65 21.3002C13.43 22.0802 14.7 22.0802 15.48 21.3002L19.72 17.0602C20.51 16.2802 20.51 15.0102 19.73 14.2302ZM14.07 19.8802L12.66 18.4702L16.9 14.2302L18.31 15.6402L14.07 19.8802Z"
  />
</template>
